import React from 'react'

import Status from '@components/Status'
import {
	AI_GENERATION_STATUS_LABELS as LABELS,
	AiGenerationStatus,
} from '@models/aiGeneration.model'

interface Props {
	status: AiGenerationStatus
	error?: string | null
}

// "Concluída" é verde; "convertendo" é azul porque ainda não é resultado; e
// falha é vermelha com o motivo à vista — uma conversão que quebrou sem motivo
// legível obriga a abrir o log do servidor para saber o que houve.
const TONES: Record<
	AiGenerationStatus,
	'success' | 'warn' | 'danger' | 'info'
> = {
	created: 'info',
	queued: 'info',
	processing: 'info',
	completed: 'success',
	failed: 'danger',
	canceled: 'warn',
}

export default function GenerationStatusBadge({ status, error }: Props) {
	return (
		<div className='flex flex-col gap-1'>
			<Status status={TONES[status]} className='px-3 py-1 text-sm'>
				{LABELS[status]}
			</Status>

			{error && <span className='text-sm text-red max-w-[280px]'>{error}</span>}
		</div>
	)
}
